import { render } from "./HelpLayout.vue?vue&type=template&id=6ffc28ba&scoped=true"
import script from "./HelpLayout.vue?vue&type=script&lang=js"
export * from "./HelpLayout.vue?vue&type=script&lang=js"

import "./HelpLayout.vue?vue&type=style&index=0&id=6ffc28ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffc28ba"]])

export default __exports__